import { SerializedEntity } from "@cuba-platform/rest"; // если у тебя так импортируется
import { useQuery } from "react-query";
import { getCubaREST } from "@cuba-platform/react";
import { restServices } from "cuba/services";
import moment from "moment";
import { DicRequestStatus } from "cuba/entities/base/tsadv$DicRequestStatus";
import { mainStore } from "../../../store";
import { fileDescriptorNormalize } from "app/entities/form-controller/lib/field-normalize";

export const findFields = <T>(
  fields: string[],
  res: SerializedEntity<T>,
  entityName: string,
) => {
  const fieldValues: Record<string, any> = {};

  const metaClass = mainStore?.metadata.find(
    (mci) => mci.entityName === entityName,
  );

  for (const field of fields) {
    let value = (res as any)?.[field] ?? null;

    //Логика обработки полей файлов
    if (
      metaClass?.properties.some(
        (p) =>
          p.name === field &&
          p.type === "sys$FileDescriptor" &&
          (p.cardinality === "ONE_TO_MANY" ||
            p.cardinality === "MANY_TO_ONE" ||
            p.cardinality === "MANY_TO_MANY"),
      )
    ) {
      if (value) {
        value = fileDescriptorNormalize(value);
      }
      fieldValues[field] = value;
      continue;
    }

    //Логика обработки полей дат
    if (typeof value === "string") {
      const isPureNumber = /^\d+$/.test(value);
      const hasIsoSigns = /[-Tt:Zz+]/.test(value);
      if (!isPureNumber && hasIsoSigns) {
        const date = moment(value, moment.ISO_8601, true);
        if (date.isValid()) {
          fieldValues[field] = date;
          continue;
        }
      }
    }

    if (value && typeof value === "object") {
      fieldValues[field] = value.id ?? value._instanceName ?? value;
    } else {
      fieldValues[field] = value;
    }
  }

  return fieldValues;
};
type LoadApplicationArgs<T> = {
  entityName: string;
  id: string;
  view: string;
  fields: string[];
  defaultValues?: T;
  cashTime?: number;
};

export function useLoadApplication<T>(args: LoadApplicationArgs<T>) {
  const { entityName, id, fields, view, defaultValues, cashTime } = args;

  return useQuery({
    queryKey: ["request", entityName, id],
    queryFn: async (): Promise<{
      dataInstance: SerializedEntity<T>;
      formValues: Record<string, any>;
    }> => {
      let res: SerializedEntity<T>;

      if (id === "new") {
        res = await restServices.portalHelperService.newEntity<
          SerializedEntity<T>
        >({
          entityName,
        });
      } else {
        res = await getCubaREST().loadEntity<SerializedEntity<T>>(
          entityName,
          id,
          { view },
        );
      }
      const formValues = findFields(
        fields,
        { ...res, ...defaultValues },
        entityName,
      );

      return {
        dataInstance: res,
        formValues,
      };
    },
    cacheTime: cashTime,
    staleTime: 5 * 60 * 1000,
  });
}

const fetchStatuses = async (): Promise<DicRequestStatus[]> => {
  return await getCubaREST().loadEntities<DicRequestStatus>(
    DicRequestStatus.NAME,
    { view: "_local" },
  );
};

export function useApprovalStatuses() {
  return useQuery({
    queryKey: ["dictionaries", "approvalStatus"],
    queryFn: fetchStatuses,
    staleTime: 1000 * 60 * 10,
  });
}
